import { render, staticRenderFns } from "./search-mobile-bar.vue?vue&type=template&id=a80b9e84&scoped=true"
import script from "./search-mobile-bar.vue?vue&type=script&lang=js"
export * from "./search-mobile-bar.vue?vue&type=script&lang=js"
import style0 from "./search-mobile-bar.vue?vue&type=style&index=0&id=a80b9e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80b9e84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
